module.exports = __webpack_public_path__ + "static/js-img-9b6fa95c5df2c1a67071b74a284c1301.jpg";